// NOTE: No longer used. We are using @rails/activestorage/src/blob_upload now.
import isEmpty from 'lodash/isEmpty';

// TODO: use XMLHttpRequest instead of fetch to track upload progress
function useBlobUpload() {
  async function setHash(hash, body) {
    if (isEmpty(hash)) return;

    const method  = 'PUT';
    const url     = hash.url;
    const headers = JSON.parse(hash.headers);

    return new Promise(async function(resolve, reject) {

      const xhr = new XMLHttpRequest;
      xhr.open(method, url, true);
      xhr.responseType = "text";

      for (const key in headers) {
        xhr.setRequestHeader(key, headers[key]);
      }

      //
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#events
      // * progress
      //

      xhr.addEventListener("load", event => resolve(true) );

      xhr.addEventListener("error", event => {
        reject(xhr.response);
        console.error('use-blob-upload-error', { event, method, headers, url })
      });

      xhr.send(body.slice());
    });
  }

  return [setHash];
}

export default useBlobUpload;
